import { createSelector } from "reselect";

export const selectCrmLead = state => state.crmLead;

export const selectHasLead = createSelector([selectCrmLead], crmLead =>
  crmLead.telefono ? true : false
);
